<template>
    <div class="table">
        <div class="container">
            <el-form :model="formData" :rules="rules" :label-position="labelPosition" label-width="140px">
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="料架类型编号" prop="mateNo">
                            <el-input class="de-input" v-model="formData.mateNo" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="料架类型名称" prop="mateName">
                            <el-input class="de-input" v-model="formData.mateName" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="BCM号" prop="bcm">
                            <el-input class="de-input" v-model="formData.bcm" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="BCM包装名称">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="外部包装号">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="外包装长（mm）">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="外包装宽（mm）">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="外包装高（mm）">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="空箱重量（kg）">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="最大承重（kg）">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="最大仓储堆高">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="最大运输堆高">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="折叠高度（mm）">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="包装类型名称">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="保养周期">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="使用年限">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="属性">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="材质">
                            <el-select v-model="formData.material" class="handle-input">
                                <el-option key="1" label="铁" value="铁"></el-option>
                                <el-option key="2" label="塑料" value="塑料"></el-option>
                                <el-option key="3" label="铁+塑料" value="铁+塑料"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="装载量">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="平台">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="附件（照片）">
                            <el-upload ref="upload" :limit="1" action="#" :file-list="fileList" :auto-upload="false"
                                       :on-exceed="handleExceed">
                                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-row class="btn-row">
                <el-button type="primary" @click="saveMaterail">保存</el-button>
                <el-button type="primary" @click="cancel">取消</el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
    import router from '../../../../router'
    export default {
        name: 'material-rack-edit',
        data() {
            return {
                formData: {
                    mateNo: 'VB-1967434343',
                    mateName: '',
                    name: '123456',
                    bcm: '00000000',
                    color: 'red',
                    packageName: '24232',
                    material: '铁',
                    total: 77,
                    attachment: '888',
                    updateTime: '2019-09-09',
                    updateUser: '9999',
                    fileName: ''
                },
                labelPosition: 'right',
                rules: {
                    mateNo: [{required: true, message: '请输入料架类型编号', trigger: 'blur' }],
                    mateName: [{required: true, message: '请输入料架类型名称', trigger: 'blur' }],
                    bcm: [{required: true, message: '请输入BCM号', trigger: 'blur' }]
                },
                fileList:[]
            }
        },
        created(){
            let no = this.$route.params.no;
            if(no){
              this.getMaterialDetail(no);
            }
        },
        methods: {
            /**
             * 保存material
             */
            saveMaterail(){

            },
            /**
             * 取消编辑
             */
            cancel(){
                router.replace({
                    path: './material-rack'
                });
            },
            /**
             * 获取materail详情信息
             * @param no
             */
            getMaterialDetail(no){

            },
            handleExceed(files,fileList){
                console.dir(files);
                console.dir(fileList);
            }
        }
    }
</script>
<style scoped>
    .btn-row{
        margin-bottom: 20px;
        margin-top: 10px;
        text-align: center;
    }
    .de-input{
        width:60%;
    }
    .handle-input{
        width: 60%;
    }
</style>